require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-introducing-sophie-baldwin.json") })
        }
      }, "path---authors-introducing-sophie-baldwin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-introducing-sophie-baldwin!./.cache/json/authors-introducing-sophie-baldwin.json
// module id = 1293
// module chunks = 231608221292675